var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-block"},[_c('icon',{attrs:{"name":"warning"}}),_vm._v(" "),_c('div',{staticClass:"text-small text-left ml-1"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }